import React, { useEffect, useState, useMemo } from 'react';
import { FaCheck, FaExclamationCircle, FaPencilAlt, FaTimes } from 'react-icons/fa';
import Confirm from '../../../components/UI/Confirm/Confirm';
import Modal from '../../../components/UI/Modal/Modal';
import Box from '../../../hoc/Box/Box';
import NavigationItem from './NavigationItem/NavigationItem';
import classes from './NavigationItems.css';
import { EquipmentTypes } from '../../../shared/common';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const NavigationItems = (props) => {
  const [showEditForm, setShowEditForm] = useState(false);
  const [equipmentName, setequipmentName] = useState('');
  const [isequipmentNameUpdated, setEquipmentNameUpdated] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [result, setResult] = useState(null);
  const [action, setAction] = useState(null);
  const [showLedMessage, setShowLedMessage] = useState(false);
  const [isChangeActionCalled, setChangeActionCalled] = useState(false);
  let TDCSisGroupPauseEnabled = sessionStorage.getItem('groupEnabled');
  const wpaSettings = useSelector(state => state.wifiSecurity.wifiSecurity)
  const location = useLocation();
  const isThreadNetworkPage = location.pathname === '/threadnetworkoverview';


  useEffect(() => {
    const _equipmentName = props.selectedEquipment.nickname
      ? props.selectedEquipment.nickname
      : props.selectedEquipment.defaultName
        ? props.selectedEquipment.defaultName
        : '';
    if (
      props.selectedEquipment &&
      (!isChangeActionCalled || equipmentName !== _equipmentName)
    ) {
      setequipmentName(_equipmentName);
      setChangeActionCalled(false);
      setShowEditForm(false);
    }
  }, [props.selectedEquipment]);

  useEffect(() => {
    if (props.success || props.error) {
      setShowEditForm(false);
    }
  },[props.succes, props.error]);

  const isValidPassword = (value) => {
    var passwordRegex = new RegExp(
      '^((?=.*[a-z])|(?=.*[A-Z])|(?=.*[0-9])|(?=.*[!@#%*:\\[~(_)\\-+={}|,.?/ \\]]))(?!.*[\\^\\\\><;`"$&\'])'
    );
    // if (/\s+$/.test(value) || /^\s/.test(value)) {
    //   return false;
    // } else
    return passwordRegex.test(value);
  };

  const isValidPodName = (nickname) => {
    // eslint-disable-next-line
    const podNameRegex = /[$\\<>"'^`&;]$/;
    const podNameTrailSpaceChecking = /^{}|\s$/;
    let isValid = true;
    let errorMessage = '';
    if (nickname && (nickname.length < 3 || nickname.length > 30)) {
      isValid = false;
    }
    if (nickname === ' ') {
      isValid = false;
      errorMessage = 'Space is only allowed in between the characters. Special characters are not allowed  $ < > `\\ ^ & ; \' "';
    }
    if (!isValidPassword(nickname)) {
      isValid = false;
      errorMessage = 'Space is only allowed in between the characters. Special characters are not allowed  $ < > `\\ ^ & ; \' "';
    }
    let existingNickname;
    if (props.selectedEquipment) {
      existingNickname = props.selectedEquipment.nickname || props.selectedEquipment.defaultName;
    }
    if (existingNickname === nickname) {
      isValid = false;
    }
    if (podNameRegex.test(nickname) || podNameTrailSpaceChecking.test(nickname)) {
      isValid = false;
      errorMessage = 'Space is only allowed in between the characters. Special characters are not allowed  $ < > `\\ ^ & ; \' "';
    }
    if (/\s{3,}/g.test(nickname)) {
      isValid = false;
      errorMessage = 'Space is only allowed in between the characters.';
    }
    return { validPodName: isValid, errorMessage };
  };

  const allEquipmentContent = (
    <span className={classes.allequipment}>
      <b>{isThreadNetworkPage ? 'Thread Network' : 'All Equipment'}</b>
    </span>
  )
  const routerContent = (showEditForm) => {
    const { ip, id} = props.realWan || {};
    let className = classes.left_text + ' ';
    className = showEditForm
      ? className + classes.router_edit_type
      : className + classes.router_type;
    return (
        <div
          className={classes.equipmentHeader}
          style={{
            paddingLeft: 15,
            display: 'flex',
            width: '100%',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ display: 'flex', color: 'white', paddingBottom: '4px' }}>
            Router: {sessionStorage.getItem('vendorModel') || 'unknown'}
          </div>
          <div>
          <div
          className={classes.routerRightContent}
            style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            color: 'white',
          }}
        >
          <span id = 'wpaSecurity' style={{ fontSize: '0.75em' }}>
            WiFi Security
              <br />
              {/* <div>
                {props.realSettings.hasOwnProperty('6ghz_wifi') && wpaSettings && wpaSettings.WPA_MODE_24GHZ_PRIMARY ? `2.4 GHz: ${wpaSettings.WPA_MODE_24GHZ_PRIMARY.value}` : ''}
                {props.realSettings.hasOwnProperty('6ghz_wifi') && wpaSettings && wpaSettings.WPA_MODE_5GHZ_PRIMARY ? `| 5 GHz: ${wpaSettings.WPA_MODE_5GHZ_PRIMARY.value}` : ''}
                {!props.realSettings.hasOwnProperty('6ghz_wifi') && props.realSettings.hasOwnProperty('2ghz_wifi') ? `2.4 GHz: ${props.realSettings['2ghz_wifi']?.subscriber.security_mode}` : ''}
                {!props.realSettings.hasOwnProperty('6ghz_wifi') && props.realSettings.hasOwnProperty('5ghz_wifi') ? `| 5 GHz: ${props.realSettings['5ghz_wifi']?.subscriber.security_mode}` : ''}
                {props.realSettings.hasOwnProperty('6ghz_wifi') ? `| 6 GHz: ${props.realSettings['6ghz_wifi']?.subscriber.security_mode}` : ''}
              </div> */}
            {props.realSettings.hasOwnProperty('2ghz_wifi') ? `2.4 GHz: ${props.realSettings['2ghz_wifi']?.subscriber.security_mode}` : ''}
            {props.realSettings.hasOwnProperty('5ghz_wifi') ? `| 5 GHz: ${props.realSettings['5ghz_wifi']?.subscriber.security_mode}` : ''}
            {props.realSettings.hasOwnProperty('6ghz_wifi') ? `| 6 GHz: ${props.realSettings['6ghz_wifi']?.subscriber.security_mode}` : ''}
          </span>
          <div style={{ paddingTop: '0.5em', display: 'flex' }}>
          <span style={{ paddingRight: '0.5em' }}>LAN IP: {ip || 'N/A'}</span>
            <span>MAC: {id.toLowerCase() || 'N/A'}</span>
            </div>
          </div>
         </div>
        </div>
      )
  }
  const podsContent = (showEditForm, editForm) => {
    const {serialNumber, ip } = props.selectedEquipment || {};
    if(!sessionStorage.getItem("featureFlags").includes('isVar')){

      return (
        <Box>
          <div
            className={classes.equipmentHeader}
            style={{
              zIndex: 10,
              paddingLeft: 15,
              display: 'flex',
              width: '100%',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
            }}
          >
            {editForm}
            {!showEditForm ? (
              <div className={classes.podLeftContent}>
                <div
                  id="podLeftContent"
                  className={classes.podLeftContent}
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    color: 'white',
                  }}
                >
                  <span>LAN IP: {ip || 'N/A'}</span>
                  <span style={{ paddingLeft: 15 }}>
                    Serial No: {serialNumber || 'N/A'}
                  </span>
                </div>
              </div>
            ) : (
              <div className={classes.podLeftContent}>
                <div
                  id="podLeftContent"
                  className={classes.podLeftContent}
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    color: 'white',
                  }}
                >
                  <span className={classes.showDesktop}>
                    LAN IP: {ip || 'N/A'}
                  </span>
                  <span
                    className={classes.showDesktop}
                    style={{ paddingLeft: 15 }}
                  >
                    Serial No: {serialNumber || 'N/A'}
                  </span>
                </div>
              </div>
            )}
          </div>
          {/* {errorMessage} */}
        </Box>
      );
    }else{
      return(
        <div></div>
      )
    }
  }

  let headerContent;
  const { type } = props.selectedEquipment || {};
  if (isThreadNetworkPage) {
    headerContent = allEquipmentContent;
  } else if (type === EquipmentTypes.Equipment) {
    headerContent = allEquipmentContent;
  }
  if (type === EquipmentTypes.Router) {
    headerContent = routerContent(showEditForm);
  }
  if (type === EquipmentTypes.Pod) {
    let podIsDisconnected = false;

    if (props.realEquipment && props.realEquipment.claimedPods && props.realEquipment.claimedPods.length) {
      // Check if the selected pod has been claimed
      props.realEquipment.claimedPods.forEach(pod => {
        if (props.selectedEquipment.podId === pod.id) {
          if (props.checkingWan || ((props.wan && props.wan.podTimer && props.wan.rebootPodId === pod.id) || (pod.connectionState !== undefined && pod.connectionState === 'disconnected'))) {
            // In here we can confirm the pod is NOT connected, so:
            // - Display a text cursor over the pod's name as per SCPW-97
            // - Display the `nickname` edit form
            podIsDisconnected = true;
          }
        }
      });
    }

    const { nickname, defaultName, claimed } = props.selectedEquipment || {};
    let className = classes.left_text + ' ';
    className = showEditForm
      ? className + classes.pod_edit_type
      : className + classes.pod_type;
    let { validPodName, errorMessage } = isValidPodName(equipmentName);
    let rightContentClassName = classes.podRightContentShow;
    if (nickname && nickname.length <= 10) {
      rightContentClassName += ' ' + classes.podRightContentShow10;
    } else if (nickname && nickname.length > 10 && nickname.length <= 20) {
      rightContentClassName += ' ' + classes.podRightContentShow20;
    } else if (nickname && nickname.length > 20) {
      rightContentClassName += ' ' + classes.podRightContentShow30;
    }

    const editIcon = podIsDisconnected ?
        (<span id="podRightContentShow"> </span>)
      : (
        <span id="podRightContentShow">
          <FaPencilAlt
            onClick={() => {
              setShowEditForm(true);
            }}
          />
        </span>
      );


    let editForm;
    if (claimed) {
      if (showEditForm) {
        editForm = (
          <div
            className={
              showLedMessage
                ? classes.podSelectionWithLedHeaderContent
                : classes.podSelectionHeaderContent
            }
          >
            <div
              className={classes.podRightContentEdit}
              style={{
                display: 'flex',
                color: 'white',
                cursor: 'pointer',
                paddingBottom: '10px',
              }}
            >
              <p style={{ display: 'flex' }}>
                Extender:{' '}
                {
                  <input
                    aria-label={"Extender"}
                    id="podRightContentEdit"
                    style={{
                      marginTop: 0,
                      height: 12,
                      marginLeft: '3px',
                      whiteSpace: 'pre',
                      borderColor: isequipmentNameUpdated
                        ? validPodName
                          ? 'green'
                          : 'red'
                        : '',
                    }}
                    value={equipmentName}
                    minLength={1}
                    maxLength={30}
                    onBlur={() => {
                      setequipmentName(nickname || defaultName);
                      setShowLedMessage(false);
                      setShowEditForm(false);
                      props.setLocatePod({
                        pSerial: props.selectedEquipment.serialNumber,
                        mode: false,
                      });
                    }}
                    onFocus={() => {
                      setShowLedMessage(true);
                      props.setLocatePod({
                        pSerial: props.selectedEquipment.serialNumber,
                        mode: true,
                      });
                    }}
                    onChange={(e) => {
                      setequipmentName(e.target.value);
                      setEquipmentNameUpdated(true);
                    }}
                    autofocus="true"
                  />
                }
              </p>
              <p style={{ marginLeft: 5, cursor: 'pointer' }}>
                {!showEditForm ? (
                  editIcon
                ) : (
                  <span>
                    <FaCheck
                      id="podRightContentSave"
                      className={
                        validPodName
                          ? classes.saveEnabled
                          : classes.saveDisabled
                      }
                      style={{ paddingLeft: '10px' }}
                      onMouseDown={() => {
                        if (validPodName) {
                          changeEquipmentName();
                        }
                      }}
                      {...(!validPodName ? { color: 'lightgrey' } : { color: 'yellowgreen' })}
                    />
                    <FaTimes
                      id="podRightContentCancel"
                      onMouseDown={() => {
                        setequipmentName(nickname || defaultName);
                        setShowEditForm(false);
                        setEquipmentNameUpdated(false);
                        props.setLocatePod({
                          pSerial: props.selectedEquipment.serialNumber,
                          mode: false,
                        });
                        setShowLedMessage(false);
                      }}
                      style={{ paddingLeft: '10px' }}
                      color="red"
                    />
                  </span>
                )}
              </p>
            </div>
            <div className={classes.warningMsgStyling}>
              <span
                id="LEDFlashMessage"
                className={[classes.ledFlashMsg, classes.ErrorMessage].join(
                  ' '
                )}
                style={{ color: '#fff', paddingLeft: '37px' }}
              >
                {showLedMessage ? (
                  <span>
                    <FaExclamationCircle />
                    <span> The LED on this Extender will begin flashing green.</span>
                  </span>
                ) : (
                  <span />
                )}
              </span>
              <span
                id="ErrorMessage"
                className={[classes.ledFlashMsg, classes.ErrorMessage].join(
                  ' '
                )}
                style={{ color: '#fff', paddingLeft: '37px' }}
              >
                {!validPodName ? errorMessage : <span />}
              </span>
            </div>
          </div>
        );
      } else {
        let podNameDefault = nickname ? nickname : defaultName;
        let headerPodStyling =
          podNameDefault.length <= 20 ? { paddingBottom: '17px' } : {};

        editForm = (
          <div style={headerPodStyling}>
            <div
              className={rightContentClassName}
              style={podIsDisconnected ? { display: 'flex', color: 'white', cursor: 'text' } : { display: 'flex', color: 'white', cursor: 'pointer' }}
            >
              <p style={{ display: 'flex' }}>
                Extender:{' '}
                {
                  <span
                    style={{ paddingLeft: '3px', whiteSpace: 'pre-wrap' }}
                    className={classes.podNickName}
                    id="podnickname"
                  >
                    {nickname ? nickname : defaultName}{' '}
                  </span>
                }
              </p>
              <p style={{ marginLeft: 5, cursor: 'pointer' }}>{editIcon}</p>
            </div>
          </div>
        );
      }
    } else {
      editForm = (
        <div
          className={
            !showEditForm ? rightContentClassName : classes.podRightContentEdit
          }
          style={{ display: 'flex', color: 'white' }}
        >
          <p style={{ display: 'flex' }}>
            Extender: <span>Unclaimed Extender </span>{' '}
          </p>
        </div>
      );
    }
    headerContent = podsContent(showEditForm, editForm);
  }

  const getNavigationItems = useMemo(() => {
    if (isThreadNetworkPage) {
      return [
        {
          link: '/threadnetworkoverview',
          exact: true,
          isDesktop: false,
          isMobile: false,
          label: 'Overview',
          type: EquipmentTypes.Equipment,
        },
      ];
    }
    const { type } = props.selectedEquipment || {};
    if (type === EquipmentTypes.Router) {
      return [
        {
          link: '/overview',
          exact: true,
          isDesktop: false,
          label: 'Overview',
          type: EquipmentTypes.Router,
        },
        {
          link: '/devices',
          exact: true,
          isDesktop: false,
          label: 'Devices',
          type: EquipmentTypes.Router,
        },
      ];
    }
    if (type === EquipmentTypes.Equipment) {
      if (TDCSisGroupPauseEnabled === 'disabled') {
        return [
          {
            link: '/overview',
            exact: true,
            isDesktop: false,
            isMobile: false,
            label: 'Overview',
            type: EquipmentTypes.Equipment,
          },
          {
            link: '/devices',
            exact: true,
            isDesktop: false,
            label: 'Devices',
            type: EquipmentTypes.Equipment,
          },
          {
            link: '/advancedconfigurations',
            exact: true,
            isDesktop: true,
            label: 'Advanced Configuration',
            type: EquipmentTypes.Equipment,
          },
        ];
      } else {
        return [
          {
            link: '/overview',
            exact: true,
            isDesktop: false,
            isMobile: false,
            label: 'Overview',
            type: EquipmentTypes.Equipment,
          },
          {
            link: '/devices',
            exact: true,
            isDesktop: false,
            label: 'Devices',
            type: EquipmentTypes.Equipment,
          },
          {
            link: '/network',
            exact: true,
            isDesktop: false,
            label: 'Network',
            type: EquipmentTypes.Equipment,
          },
          {
            link: '/advancedconfigurations',
            exact: true,
            isDesktop: true,
            label: 'Advanced Configuration',
            type: EquipmentTypes.Equipment,
          },
        ];
      }
    }
    if (type === EquipmentTypes.Pod) {
      return [
        {
          link: '/overview',
          exact: true,
          isDesktop: false,
          isMobile: false,
          label: 'Overview',
          type: EquipmentTypes.Pod,
        },
        {
          link: '/devices',
          exact: true,
          isDesktop: false,
          label: 'Devices',
          type: EquipmentTypes.Pod,
        },
      ];
    }
    if (type === EquipmentTypes.IOT) {
      return [
        {
          link: '/psd/property-routes',
          exact: true,
          isDesktop: false,
          isMobile: false,
          label: 'Property Routes',
          type: EquipmentTypes.IOT,
        },
        {
          link: '/psd/devices',
          exact: true,
          isDesktop: false,
          isMobile: false,
          label: 'Devices',
          type: EquipmentTypes.IOT,
        },
      ];
    }
    return [
      {
        link: '/overview',
        exact: true,
        isDesktop: false,
        isMobile: false,
        label: 'Overview',
        type: 'global',
      },
      {
        link: '/devices',
        exact: true,
        isDesktop: false,
        label: 'Devices',
        type: 'global',
      },
      {
        link: '/advancedconfigurations',
        exact: true,
        isDesktop: true,
        label: 'Advance Configuartion',
        type: 'global',
      },
    ];
  }, [props.selectedEquipment, isThreadNetworkPage]);

  function confirmModalConfirmHandler() {
    if (action === 'change your Extender name') {
      props.changeEquipmentName({
        pSerial: props.selectedEquipment.serialNumber,
        nickName: equipmentName.trim(),
      });
    }

    confirmModalCancelHandler();
  }
  function confirmModalCancelHandler() {
    setConfirmModal(false);
  }

  function changeEquipmentName() {

    setChangeActionCalled(true);
    setEquipmentNameUpdated(false);
    props.changeEquipmentName({
      pSerial: props.selectedEquipment.serialNumber,
      nickName: equipmentName,
    });
    // props.setLocatePod({ pSerial: props.selectedEquipment.serialNumber, mode: false });
  }

  return (
    <React.Fragment>
      <div className={classes.header_row + ' ' + classes.navContainer}>
        {headerContent}

        <div className={classes.navItem + ' ' + classes.nav_item_xs_12}>
          <ul className={classes.NavigationItems}>
            {getNavigationItems.map((nav, index) => {

              if (nav.isDesktop) {
                return (
                  <React.Fragment key={nav.label}>
                    <div className={classes.showDesktop} >
                      <NavigationItem link={nav.link}  key={index+nav.label}>
                        {nav.label}
                      </NavigationItem>
                    </div>
                    <div className={classes.showMobile}>
                      <NavigationItem  link={nav.link} key={index+nav.label}>
                        Configurations
                      </NavigationItem>
                    </div>
                  </React.Fragment>
                );
              }
              return (
                <NavigationItem key={nav.label} link={nav.link}>
                  {nav.label}
                </NavigationItem>
              );
            })}
          </ul>
        </div>
        <div>
        </div>
      </div>
      <Modal show={confirmModal} modalClosed={confirmModalCancelHandler}>
        <Confirm
          action={action}
          result={result}
          confirm={confirmModalConfirmHandler}
          cancel={confirmModalCancelHandler}
          deviceGroupConfirmation
        />
      </Modal>
    </React.Fragment>
  );
};

export default NavigationItems;
